// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5279b6a020cca1eec303","138":"1122b19b72df608b8d0c","139":"2f3c75646c90d1580bb4","188":"e26e0ab66641d320a432"}[chunkId] + ".chunk.js";
};